/*
  import { garagesList } from '@/services/AccountSettings/Garages/list'
*/

import Vue from 'vue'
import Vuex from 'vuex'
import _get from 'lodash/get'

import { notifyProblem, notifyError, notifyMessage } from '@/services/notify'
import kms from '@/services/kms'

const isDebug = true

/* eslint-disable no-empty-pattern */
const actions = {
  /*
    const { list } = await garagesList.dispatch ('getGarageList', {
      hoaId
    });
  */
  async getGarageList({}, { hoaId }) {
    console.log('in getGarageList...')
    try {
      const result = await kms.get('/ParkingSpaces/Garage/List', {
        params: {
          hoaId
        }
      })

      if (isDebug == true) console.debug('getGarageList log=' + JSON.stringify(result))

      return {
        list: result.results
      }
    } catch (exception) {
      notifyProblem(`The garages list could not be retrieved.`)
      console.error(exception)
    }

    return {
      list: []
    }
  },

  async deleteGarage({ dispatch }, { garageID, done }) {
    try {
      const path = `/ParkingSpaces/Garage/${garageID}?forceDelete=false`

      const results = await kms.delete(path)

      if (this.isDebug == true) console.debug('results=' + JSON.stringify(results))

      if (dispatch && dispatch != undefined) console.debug(dispatch)

      const wasDeleted = _get(results, 'deleted', false)

      if (wasDeleted === true) {
        notifyMessage(`Successfully deleted this garage.`)
        done()
      } else {
        notifyError('There was a problem deleting the garage.')
      }
    } catch (exception) {
      notifyProblem(`There was a problem deleting this garage.`)
      console.error(exception)
    }
  }
}
/* eslint-enable no-empty-pattern */

Vue.use(Vuex)
export const garagesList = new Vuex.Store({
  state: {},
  mutations: {},
  getters: {},
  actions
})
